// services/devicesApi.ts
import api from './api';
import { Device, RegisterDeviceRequest, RegisterDeviceResponse, UpdateDeviceRequest, AddDeviceRequest, AddDeviceResponse } from '../types/devices';

export const devicesApi = {
    getAllDevices: async (): Promise<Device[]> => {
        const response = await api.get('/devices');
        const devices: Device[] = response.data;
        
        // Fetch system status for each device
        const devicesWithStatus = await Promise.all(
            devices.map(async (device: Device) => {
                try {
                    const statusResponse = await api.get(`/SystemStatus/device/${device.deviceId}`);
                    return {
                        ...device,
                        currentStatus: statusResponse.data.metrics,
                        statusReasons: statusResponse.data.statusReasons
                    };
                } catch (error) {
                    console.error(`Failed to fetch status for device ${device.deviceId}:`, error);
                    return device;
                }
            })
        );
        
        return devicesWithStatus;
    },

    getDevice: async (id: number): Promise<Device> => {
        const response = await api.get(`/devices/${id}`);
        return response.data;
    },

    registerDevice: async (request: RegisterDeviceRequest): Promise<RegisterDeviceResponse> => {
        const response = await api.post('/devices/register', request);
        return response.data;
    },

    // Add this method to devicesApi.ts
    addDevice: async (deviceData: {
        deviceName: string;
        locationId?: number;
        username?: string;
        password?: string;
        enableSsh?: boolean;
        timezone?: string;
        keyboardLayout?: string;
        wifiSsid?: string;
        wifiPassword?: string;
        wifiCountry?: string;
    }): Promise<AddDeviceResponse> => {
        const response = await api.post('/devices/add', deviceData);
        return response.data;
    },
  
    updateDevice: async (id: number, request: UpdateDeviceRequest): Promise<void> => {
        await api.put(`/devices/${id}`, request);
    },

    deleteDevice: async (id: number): Promise<void> => {
        await api.delete(`/devices/${id}`);
    },   

    requestPiConnect: async (deviceId: number): Promise<void> => {
        const response = await api.post(`/devices/${deviceId}/request-pi-connect`, {});
        return response.data;
    },

    getPiConnectStatus: async (deviceId: number): Promise<{ piConnectRequestFlag: boolean }> => {
        // USE THE CONFIGURED API INSTANCE, NOT FETCH!
        const response = await api.get(`/devices/${deviceId}/pi-connect-status`);
        return response.data;
    },

    refreshDevice: async (deviceId: number): Promise<Device> => {
        // Reuse the existing getDevice method
        return devicesApi.getDevice(deviceId);
    }
};